import { Box, Flex, Skeleton } from '@chakra-ui/react';
import React, { useMemo } from 'react';

import { Funding } from '@finley-technologies/finley-types';

import { InputContainer, TextInput, SelectInput } from './Inputs';
import { useEditLoanContext } from './useEditLoanContext';

export const LoanMetadataEditForm = () => {
  const context = useEditLoanContext();

  const pricingOptions = useMemo(
    () =>
      context.status === 'ready'
        ? context.state.initial.resolvedLoan.facility.loanMechanics.pricingOptions.map(
            (pricingOption: Funding.PricingOption) => ({
              label: pricingOption.name,
              value: pricingOption.key,
            }),
          )
        : [],
    [
      context.status,
      context.state?.initial.resolvedLoan.facility.loanMechanics.pricingOptions,
    ],
  );

  if (context.status !== 'ready') {
    // TODO: add loading state
    return <Skeleton w="100%" h="10rem" />;
  }

  return (
    <Flex width="100%" gap="1rem" alignItems="flex-start" direction="column">
      <InputContainer label="External Loan Id">
        <TextInput name="externalLoanId" hintText="Optional" />
      </InputContainer>
      <InputContainer label="Pricing Option">
        <Box w="100%">
          <SelectInput name="pricingOptionKey" options={pricingOptions} />
        </Box>
      </InputContainer>
    </Flex>
  );
};
